import React from 'react'
import { ReactComponent as WarningIcon } from '../../../../../assets/icons/warning.svg'
import BaseModal from '../BaseModal'
import Button from '../../../../../components/Form/Button'

const IsMobileModal = ({ visibility = false, setVisibility = undefined }) => {
  return (
    <BaseModal
      type='warning'
      mobile
      titleVariation={`
        font-size: 16px;
        font-weight: 600;
        text-align: center;
      `}
      visibility={visibility}
      setVisibility={setVisibility}
      icon={<WarningIcon />}
      title='Importante: Melhor experiência pelo computador'
      subTitle='Para uma melhor navegação, recomendamos que acesse a área veterinária pelo seu notebook, desktop ou tablet. Em breve, iremos oferecer uma experiência otimizada também para o celular.'
    >
      <Button size='medium' type='button' color='#028BB7' onClick={setVisibility}>Fechar</Button>
    </BaseModal>
  )
}

export default IsMobileModal
